import { GetYoutubeVideoPreviewQueryParam } from '../../../Shared/Services/QueryParamService'

export const useYtVideoIdParam = () => {
  const q = GetYoutubeVideoPreviewQueryParam()
  return q
}
